/*
 * Collection copy block: collapse behind "Read more" only when there is
 * something to collapse. See snippets/forcast-collection-copy.liquid.
 *
 * The text is server-rendered in full and the collapsed height is a CSS
 * custom property (--forcast-collection-copy-collapsed, assets/collection.css),
 * so this only decides whether the block overflows that height and, if it
 * does, wires the toggle. No JS, or a short piece of copy, and the block
 * simply shows everything.
 */
(function forcastCollectionCopy() {
  const block = document.querySelector('[data-forcast-collection-copy]');
  if (!block) return;
  const inner = block.querySelector('.forcast-collection-copy__inner');
  const toggle = block.querySelector('.forcast-collection-copy__toggle');
  if (!inner || !toggle) return;

  const collapsedHeight = parseFloat(getComputedStyle(block).getPropertyValue('--forcast-collection-copy-collapsed')) || 0;
  // Fonts and images can still be settling; a few pixels of slack stops a
  // block that is barely over the line from earning a toggle that reveals a
  // single word.
  if (!collapsedHeight || inner.scrollHeight <= collapsedHeight + 8) return;

  block.classList.add('forcast-collection-copy--collapsible');
  toggle.hidden = false;

  toggle.addEventListener('click', () => {
    const open = block.classList.toggle('forcast-collection-copy--open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.textContent = open ? toggle.dataset.labelLess : toggle.dataset.labelMore;
    if (!open) block.scrollIntoView({ block: 'nearest', behavior: 'instant' });
  });
})();
